module.exports = __webpack_public_path__ + "static/media/ic-dot-active.8ae91741.svg";